export default __webpack_public_path__ + "static/media/160x90.56a74634.jpg";